export default {
  name: "Юр. жактын аталышы",
  entity: "Юр. жак",
  iik: "ИИК",
  inn: "ИНН",
  bin: "БИН",
  bic: "БИК",
  bankBic: "Банк БИК",
  bankMFO: "Банк МФУ",
  codeFiscal: "Фискалдык код",
  head_name_description:
    "Автоматтык түрдө акттар жана эсептер түзүлө турган жооптуу адамдын Ф.И.О. киргизиңиз",
  mainOrganization: "Негизги юр. жак",
  mainOrganizationHint:
    "Негизги юр. жак тариф сатып алуу үчүн колдонулат жана анын мөөнөтү аяктагандан кийин жаңы тариф төлөнбөсө да активдүү бойдон калат. Негизги юр. жакты 14 күндөн көбүрөөк өзгөртүүгө болбойт",
  chooseMainOrganization: "Юр. жакты тандаңыз",
  maxOrganizationError: "Максималдуу сандагы уюм түзүлгөн",
  moderOrganizationError: "Модерация жүрүп жатканда жаңы уюм кошууга болбойт",
  aboutTitle: "Сиздин уюм тууралуу маалымат",
  typeOrganization: "Уюмдун түрү",
  bankName: "Банк аты",
  legalAddress: "Юридикалык дарек",
  currentAccountNumber: "Эсеп номери",
  correspondentAccount: "Корсчет",
  vatCode: "НДС коду",
  addressFieldRequired: "Юр. жак дареги киргизилген эмес",
  metaIsRequired: "Банктын реквизиттери киргизилген эмес",
  add: {
    button: "Юрдик жак түзүү",
  },
  entities: "Юр. жактар",
  head_name: "Башчынын Ф.И.О.",
  ogrn: "ОГРН",
  ogrnOgrnip: "ОГРН / ОГРНИП",
  legalTypes: "Юр. жак формасы",
  taxSystem: "Салык системасы",
  monthlyTurnover: "Айлык айланма",
  depositSum: "Депозит суммасы",
  okvedLabel: "Негизги ишмердүүлүк түрү",
  legalEntityCharter: "Юр. жактын уставы",
  mainEntity: "Негизги",
  mainEntityInfo: [
    "Негизги юр. жак тариф сатып алуу үчүн колдонулат жана мөөнөтү аяктагандан кийин жаңы тариф төлөнбөсө да активдүү бойдон калат.",
    "Негизги юр. жакты 14 күндөн көбүрөөк өзгөртүүгө болбойт.",
  ],
  cantCreateModal: {
    title: "Сиз тариф боюнча максималдуу сандагы юр. жактарды түздүңүз",
  },
  deposit: "Депозит",
  enterInnOrEntityName: "ИНН же юр. жактын атын киргизиңиз",
  entityCreating: "Юр. жак түзүлүүдө",
  updateEntityNotifyMessage: {
    create: "Юр. жак модерацияга жөнөтүлдү",
    edit: "Юр. жак тууралуу маалымат ийгиликтүү өзгөртүлдү",
  },
  commercial: "Коммерциялык юр. жак",
  uncommercial: "Коммерциялык эмес юр. жак",
  depositMinSumHint:
    "Эсептеги минималдуу калган сумма. Сумма {minDeposit} RCден кем болбошу керек жана каражат чыгарганда балансында калат.",
  entityType: "Юр. жактын түрү",
  entityInfo: "Юр. жак тууралуу маалымат",
  bankDetails: "Банктын реквизиттери",
  frequencyMainEntityChanging:
    "Негизги юр. жакты 14 күндөн көп өзгөртүүгө болбойт.",
  abailableChangeMainEntity:
    "Негизги юр. жакты өзгөртүү {nextChangeDate} датасынан баштап жеткиликтүү болот.",
  mainEntityDescription:
    "Тариф сатып алуу үчүн колдонулат жана мөөнөтү аяктагандан кийин жаңы тариф төлөнбөсө да активдүү бойдон калат.",
  entityHasHalal: "Юр. жак Халяль сертификатына ээ",
  headNameToSendActs:
    "Автоматтык түрдө акттар жана эсептер түзүлө турган жооптуу адамдын Ф.И.О.",
  certHalal: "Халяль сертификаты",
  makeMainEntity: "{entityName} негизги юр. жак болсунбу?",
  successChangedMainEntity: "Негизги юр. жак ийгиликтүү өзгөртүлдү",
  mainEntityUseForBuyingTariff:
    "Негизги юр. жак тариф сатып алуу үчүн колдонулат жана мөөнөтү аяктагандан кийин жаңы тариф төлөнбөсө да активдүү бойдон калат.",
  afterConfirmYouCanChangeMainEntityIn14Days:
    "«Тастыктоо» баскычын баскандан кийин, негизги юр. жакты кайра өзгөртүү 14 күндөн эрте мүмкүн эмес.",
  cancelCreationModal: {
    title: "Юр. жак түзүүнү токтотосузбу?",
    subtitle:
      "Киргизилген маалыматтар сакталбайт. Юр. жак түзүүнү улантуу үчүн «Артка» басыңыз.",
  },
  pressBackToSave:
    "Өзгөртүүлөрдү сактоо же түзөтүүнү улантуу үчүн «Артка» баскычын басыңыз.",
  congratulateWithCreateEntity: "Юр. жак түзүлгөнү менен куттуктайбыз!",
  entityInModerationNow:
    "Азыр сиздин юр. жак текшерүүдөн өтүп жатат. Бул процесс 24-48 саатка созулат.",
  toPassModerationPayBill:
    "Текшерүүдөн өтүү үчүн көрсөтүлгөн юр. жактан эсепти төлөшүңүз керек. Аны төмөнкү баскыч аркылуу жүктөй аласыз. Сиз ошондой эле эсепти жеке кабинетиңизде таба аласыз: «Менин ишканаларым» бөлүмүндө – «Документтер» ичинде «Тесттик төлөм» деген аталышта.",
  entityEditingNotAvailabel: "Юрдук жакты түзөтүү убактылуу жеткиликтүү эмес",
  cashPaymentBeingMade:
    "Накталай акча каражаттарын төлөө жүрүп жатат. Бул учурда юрдук жактын маалыматтарын түзөтүү мүмкүн эмес.",
  entityHasPointsWithConnectPaymentMethods:
    "Юрдук жактын төлөм ыкмалары кошулган соода чекиттери бар",
  detailsChangesAvailableOnlyIntoTechHelp:
    "Төлөм ыкмалары кошулган учурда юрдук жактын реквизиттерин өзгөртүү техникалык колдоо аркылуу гана мүмкүн <a href='mailto:hello@rc.city'>hello@rc.city</a>",
  forChangeBankDetailsTellUs:
    "Эскертүү: төлөм ыкмалары боюнча банк реквизиттерин өзгөртүү үчүн — бул тууралуу кошумча билдирүү керек.",
  uCanChangeOnlyDepositSum:
    "Өз алдынча депозит суммасын гана өзгөртсөңүз болот, ал үчүн «Түзөтүү» баскычын басыңыз.",
};
